var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 7.5C13.125 10.6066 10.6066 13.125 7.5 13.125C4.3934 13.125   1.875 10.6066 1.875 7.5C1.875 4.3934 4.3934 1.875 7.5 1.875C10.6066 1.875 13.125 4.3934 13.125 7.5ZM5.18306   9.81694C4.93898 9.57286 4.93898 9.17714 5.18306 8.93306L6.61612 7.5L5.18306 6.06694C4.93898 5.82286 4.93898 5.42714   5.18306 5.18306C5.42714 4.93898 5.82286 4.93898 6.06694 5.18306L7.5 6.61612L8.93306 5.18306C9.17714 4.93898 9.57286   4.93898 9.81694 5.18306C10.061 5.42714 10.061 5.82286 9.81694 6.06694L8.38388 7.5L9.81694 8.93306C10.061 9.17714   10.061 9.57286 9.81694 9.81694C9.57286 10.061 9.17714 10.061 8.93306 9.81694L7.5 8.38388L6.06694 9.81694C5.82286   10.061 5.42714 10.061 5.18306 9.81694Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputClear);
export default __webpack_public_path__ + "static/media/InputClear.ef908cfc.svg";
export { ForwardRef as ReactComponent };